import { LT_SAVINGS_DATA_RECEIVED, LT_SAVINGS_UNLOADED, LT_SAVINGS_DATA_SAVED, LT_SAVINGS_DATA_DELETED } from './types'
import api from 'api';

export const savingLTDataReceived = (data) => ({
  type: LT_SAVINGS_DATA_RECEIVED,
  data
})

export const savingLTDataUnload = () => ({
  type: LT_SAVINGS_UNLOADED
})

export const savingSaved = data => ({
  type: LT_SAVINGS_DATA_SAVED,
  data
})

export const savingDeleted = data => ({
  type: LT_SAVINGS_DATA_DELETED,
  data
})

export const unloadSavings = () => dispatch => {
  dispatch(savingLTDataUnload())
}

export const deleteSaving = data => dispatch =>
  api.bmc.savings.deleteSaving(data).then( saving =>{
    dispatch(savingDeleted(data))
  })

export const postSaving = data => dispatch =>
  api.bmc.savings.postSaving(data).then( saving =>{
    dispatch(savingSaved(saving))
  })
  
export const getSavings = (view = false) => (dispatch) =>
    api.bmc.savings.getSavings(view?'viewTY':'').then( savings => {
    dispatch(savingLTDataReceived(savings))
  })
